import axios, { AxiosRequestConfig, Method } from 'axios';

export const HttpRequest = async <T>(httpMethod: string, url: string, payload: any, withCredentials: boolean, jwt?: string) => {
    const config: AxiosRequestConfig = {
        method: httpMethod as Method,
        url,
        data: payload,
        headers: {
            'Accept': 'application/json'
        },
        withCredentials: withCredentials
    };
    jwt && config.headers && (config.headers['Authorization'] = `Bearer ${jwt}`);
    const response = await axios.request<T>(config);
    return response.data;
}
